import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/report";
const API_PATH_EXCEL = ConstantList.API_ENPOINT + "/api/etb/download-file";


export const reportOnTreatmentResultsForDrugResistantTuberculosis = (searchObject) => {
  var url = API_PATH + "/treatment-results-for-drug-resistant-tuberculosis";
  return axios.post(url, searchObject);
};
export const reportPreliminaryReportTreatmentResultsForDrugResistantTuberculosis = (obj) => {
  let url = API_PATH_EXCEL + "/treatment-results-for-drug-resistant-tuberculosis";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}
export const getPagePatientReportOnTreatmentResultsForDrugResistantTuberculosis = (searchObject) => {
  var url = API_PATH + "/view-patient-treatment-results-for-drug-resistant-tuberculosis";
  return axios.post(url, searchObject);
};
